import { Box } from '@mui/material';
import React, { memo, useState } from 'react';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DocumentViewerBase64 from '../DocumentViewerBase64';
import DocumentViewer from '../DocumentViewer';

export const AttachedFile = memo(function AttachedFile({
    file,
    type = 'base64',
    title = null,
    popoverMenuOption
}) {

    const [filePreview, setFilePreview] = useState(null);
    const [openPreview, setOpenPreview] = useState(false);

    const onClickFile = (file) => {
        setFilePreview(file);
        setOpenPreview(true);
    }

    const styleProps = !popoverMenuOption ? {
        sx: {
            display: 'flex',
            alignItems: 'center',
            padding: '8px 16px 8px 0px',
            borderRadius: '4px',
            background: '#E0E1E3',
            alignSelf: 'flex-start',
            cursor: 'pointer'
        }
    } : { className: 'item-option clickable-option' }

    const textStyleProps = !popoverMenuOption ? { style: { marginLeft: 8 } } : { className: 'toggle-action' }

    const iconStyleProps = !popoverMenuOption ? {
        sx: {
            width: 21,
            height: 21,
            color: '#636A73'
        }
    } : { className: 'edit-icon' }

    return (
        <>
            <Box onClick={() => onClickFile(file)} {...styleProps}>
                <AttachFileIcon {...iconStyleProps} />
                <span {...textStyleProps}>{title || file.titulo}</span>
            </Box>

            {openPreview && type === 'base64' && <DocumentViewerBase64 data={filePreview} setOpenDlg={setOpenPreview} />}
            {openPreview && type === 'blob' && <DocumentViewer data={filePreview} setOpenDlg={setOpenPreview} />}
        </>
    )
})
